import {USE_IMAGE_PLACEHOLDERS} from "./constants/paths";
import _ from "lodash";

export const getAssetPath = (url, size) => {
    if(USE_IMAGE_PLACEHOLDERS) {
        return `https://via.placeholder.com/${size}.png`;
    }

    return url;
};

export const defaultSwalPreferences = (swalObj) => {
    return {
        toast: true,
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        onOpen: toast => {
            toast.addEventListener('mouseenter', swalObj.stopTimer);
            toast.addEventListener('mouseleave', swalObj.resumeTimer);
        }
    }
}

export const getAvatarInitials = (str) => {
    let initials = str.match(/\b\w/g) || [];
    initials = ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
    return initials;
}

export const hasPlugin = (user, plugin) =>
    _.some(user?.current_company?.enabled_plugins, { slug: plugin });

// Perfiles que administran la empresa. Desde el 2026-10-23 el supervisor tiene todo lo del admin menos manejar usuarios,
// que queda para USER_MANAGER_PROFILES (el backend lo exige igual, en Ability).
export const COMPANY_MANAGER_PROFILES = ["supervisor", "customer_admin", "superadmin"];
export const USER_MANAGER_PROFILES = ["customer_admin", "superadmin"];
// Perfiles con acceso a los datos de la empresa (los mismos de Api::Access en el backend): pueden usar Xpit Assistant.
export const DATA_PROFILES = ["reader", "supervisor", "customer_admin", "superadmin"];

export const hasProfile = (user, profile) =>
    _.some(user?.profiles, { name: profile });

export const hasAnyProfile = (user, profiles) =>
    profiles.some(p => hasProfile(user, p));

// Perfil en la empresa actual (current_profiles) o en cualquiera de las del usuario. La interfaz lo usa para mostrar u
// ocultar acciones; el backend igual lo exige.
export const hasCurrentProfile = (user, profiles) =>
    _.some(user?.current_profiles, (profile) => profiles.includes(profile?.name)) || hasAnyProfile(user, profiles);

